import React, {
    useState, useEffect, useCallback, useMemo,
} from 'react';
import classNames from 'classnames';
import { Portal } from 'react-portal';

import { tp } from 'app/utils/typograf';

import { isDesktop } from 'app/utils/resolution';
import { VideoModal } from '../VideoModal/VideoModal';

import { slidesConfig } from './videoSliderConfig';

import playIcon from './play-icon.img.svg';
import playPinkIcon from './play-icon.pink.img.svg';
// import playBlueIcon from './play-icon.blue.img.svg';
import playBrownIcon from './play-icon.brown.img.svg';
import playLightBrownIcon from './play-icon.light-brown.img.svg';
import playGreyIcon from './play-icon.grey.img.svg';
import playDarkGreyIcon from './play-icon.darkgrey.img.svg';
import './video-slider.scss';

const cardsWithGradientPages = ['romantic', 'borjomi', 'kozelbezalkoholu', 'maxim', 'hochland', 'hp', 'ny'];


const VideoSlider = ({ slidesKey }) => {
    const [selectedVideo, selectVideo] = useState(null);

    const isDesktopResolution = useMemo(
        () => isDesktop(),
        [window.innerWidth],
    );

    const slides = useMemo(
        () => {
            const slidesFromConfig = slidesConfig[slidesKey] ?? [];
            if (isDesktopResolution && slidesKey !== 'ecomilk') {
                return slidesFromConfig.slice(0, 4);
            }
            return slidesFromConfig;
        },
        [slidesKey, isDesktopResolution],
    );

    const handleSelectVideo = useCallback((e) => {
        const { dataset } = e.currentTarget;
        if (dataset.item) {
            const slide = slides.find((s) => s.id === dataset.item);
            selectVideo(slide);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCloseVideo = useCallback(() => {
        selectVideo(null);
    }, []);

    const iconPath = {
        hochland: playIcon,
        romantic: playPinkIcon,
        kozelbezalkoholu: playBrownIcon,
        halloween: playLightBrownIcon,
        maxim: playLightBrownIcon,
        hp: playIcon,
        ny: playGreyIcon,
        easterbox: playPinkIcon,
        maslenitsa: playDarkGreyIcon,
        katya: playDarkGreyIcon,
        ecomilk: playDarkGreyIcon,
    };

    const rootClasses = classNames({
        'hochland-selection-slider-root': true,
        [slidesKey]: true,
    });

    const cardClasses = classNames({
        'hochland-selection-slider-card': true,
        [slidesKey]: true,
    });

    const titleClasses = classNames({
        'hochland-selection-slider-card__title': true,
    });

    const hasGradient = cardsWithGradientPages.includes(slidesKey);

    useEffect(
        () => {
            const marchgiftsCardNodes = document.querySelectorAll('.marchgifts-card');
            if (marchgiftsCardNodes?.length) {
                marchgiftsCardNodes.forEach((node) => node.addEventListener('click', handleSelectVideo));
            }
            return () => {
                marchgiftsCardNodes.forEach((node) => node.removeEventListener('click', handleSelectVideo));
            };
        },
        [handleSelectVideo],
    );

    return (
        <div className={rootClasses}>
            {slides.map((data) => {
                const {
                    id, title, bg, isLineBreakStrict,
                } = data;

                return (
                    <button
                        type="button"
                        className={cardClasses}
                        key={id}
                        data-item={id}
                        onClick={handleSelectVideo}
                    >
                        <div className="hochland-selection-slider-card__bg">
                            {bg && (
                                <img className="hochland-selection-slider-card__bg-img" alt={title} src={bg} />
                            )}

                            <div className={`hochland-selection-slider-card__bg-gradient
                            ${hasGradient && (`hochland-selection-slider-card__bg-gradient__${slidesKey}`)}`}
                            />
                            <div className="hochland-selection-slider-card__fg">
                                <div className="hochland-selection-slider-card-button">
                                    <img
                                        src={iconPath[slidesKey]}
                                        alt=""
                                        className="hochland-selection-slider-card-button__item"
                                        style={{ objectFit: 'cover' }}
                                    />
                                </div>
                                {!isLineBreakStrict && (
                                    <div className={titleClasses}>
                                        {typeof title === 'string'
                                            ? tp.execute(title)
                                            : title}
                                    </div>
                                )}
                                {isLineBreakStrict && (
                                    <div className={titleClasses}>
                                        <div className="xxs">{data?.titleXXS}</div>
                                        <div className="xs">{data?.titleXS}</div>
                                        <div className="s">{data?.titleS}</div>
                                        <div className="m">{data?.titleM}</div>
                                        <div className="l">{data?.titleL}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </button>
                );
            })}

            {selectedVideo && (
                <VideoModal
                    video={selectedVideo}
                    handleClose={handleCloseVideo}
                />
            )}
        </div>
    );
};

/* СЛАЙДЕР С КАРТОЧКАМИ, СВЁРСТАННЫМИ В JSX */

export const VideoCardsSliderPortal = React.memo(() => {
    const sliderRootNode = document.getElementById('video-slider-portal');

    if (!sliderRootNode) {
        return null;
    }

    const slidesKey = sliderRootNode?.dataset?.slides_key;

    return (
        <Portal node={sliderRootNode}>
            <VideoSlider slidesKey={slidesKey} />
        </Portal>
    );
});
